import { Box, Stack, Typography, styled } from "@mui/material";

import { background, divider, text } from "@/theme/colors";

/** プレビュー label + boxed value — used by 請求書番号設定 (edit & detail). */
export const InvoicePreview = ({ value }: { value: string }) => (
  <Stack gap={0.5}>
    <Typography variant="cap12" color={text.primary}>
      プレビュー
    </Typography>
    <PreviewBox>
      <Typography variant="body14" color={text.primary}>
        {value}
      </Typography>
    </PreviewBox>
  </Stack>
);

const PreviewBox = styled(Box)`
  border: 1px solid ${divider.middle};
  border-radius: 4px;
  background: ${background.primary};
  padding: 6px 8px;
`;
